// src/data/surveyData.js

export const dimensions = [
  {
    id: 'leadership',
    name: 'القيادة والتقدير',
    color: '#00897B',
    description: 'الإشراف الفعال والتقدير والرؤية الملهمة'
  },
  {
    id: 'meaning',
    name: 'المعنى والتطور',
    color: '#F9A825',
    description: 'طبيعة العمل وفرص النمو والرؤية والرسالة'
  },
  {
    id: 'relationships',
    name: 'العلاقات والبيئة',
    color: '#00695C',
    description: 'زملاء العمل وبيئة العمل والثقافة التنظيمية'
  },
  {
    id: 'balance',
    name: 'التوازن والأمان',
    color: '#FDD835',
    description: 'التوازن الحياتي والأمان الوظيفي والصحة النفسية'
  },
  {
    id: 'fairness',
    name: 'العدالة والتواصل',
    color: '#757575',
    description: 'الراتب والمزايا والعدالة والتواصل الشفاف'
  }
];

export const questions = [
  // القيادة والتقدير (1-7)
  { id: 1, dimension: 'leadership', text: 'مديري المباشر يدعمني ويوجهني بشكل فعال', reverse: false },
  { id: 2, dimension: 'leadership', text: 'أحصل على التقدير المناسب عندما أنجز عملي بشكل جيد', reverse: false },
  { id: 3, dimension: 'leadership', text: 'القيادة العليا تلهمنا برؤية واضحة للمستقبل', reverse: false },
  { id: 4, dimension: 'leadership', text: 'لا أشعر أن جهودي الإضافية يتم ملاحظتها', reverse: true },
  { id: 5, dimension: 'leadership', text: 'مديري يثق بي ويمنحني الصلاحيات اللازمة', reverse: false },
  { id: 6, dimension: 'leadership', text: 'نادراً ما نحتفل بالإنجازات في منظمتنا', reverse: true },
  { id: 7, dimension: 'leadership', text: 'أثق في قرارات القيادة وتوجهاتها', reverse: false },
  
  // المعنى والتطور (8-14)
  { id: 8, dimension: 'meaning', text: 'أشعر أن عملي له معنى وقيمة حقيقية', reverse: false },
  { id: 9, dimension: 'meaning', text: 'أؤمن برسالة المنظمة وأفخر بالعمل فيها', reverse: false },
  { id: 10, dimension: 'meaning', text: 'توجد فرص واضحة للتطور والنمو المهني', reverse: false },
  { id: 11, dimension: 'meaning', text: 'أشعر أنني عالق في نفس المكان دون تقدم', reverse: true },
  { id: 12, dimension: 'meaning', text: 'عملي يتحداني ويطور من مهاراتي', reverse: false },
  { id: 13, dimension: 'meaning', text: 'قيمي الشخصية تتوافق مع قيم المنظمة', reverse: false },
  { id: 14, dimension: 'meaning', text: 'لا أرى مستقبلاً واضحاً لي في هذه المنظمة', reverse: true },
  
  // العلاقات والبيئة (15-21)
  { id: 15, dimension: 'relationships', text: 'أستمتع بالعمل مع زملائي ونتعاون بشكل ممتاز', reverse: false },
  { id: 16, dimension: 'relationships', text: 'بيئة العمل المادية مريحة ومحفزة للإنتاجية', reverse: false },
  { id: 17, dimension: 'relationships', text: 'تسود ثقافة الاحترام والدعم المتبادل', reverse: false },
  { id: 18, dimension: 'relationships', text: 'هناك صراعات مستمرة تؤثر على جو العمل', reverse: true },
  { id: 19, dimension: 'relationships', text: 'أشعر بالانتماء لفريق عملي', reverse: false },
  { id: 20, dimension: 'relationships', text: 'مكان العمل يفتقر للأدوات والموارد اللازمة', reverse: true },
  { id: 21, dimension: 'relationships', text: 'يمكنني الاعتماد على زملائي عند الحاجة', reverse: false },
  
  // التوازن والأمان (22-28)
  { id: 22, dimension: 'balance', text: 'أستطيع تحقيق توازن صحي بين العمل والحياة الشخصية', reverse: false },
  { id: 23, dimension: 'balance', text: 'أشعر بالأمان والاستقرار في وظيفتي', reverse: false },
  { id: 24, dimension: 'balance', text: 'المنظمة تدعم احتياجاتي النفسية والصحية', reverse: false },
  { id: 25, dimension: 'balance', text: 'ضغط العمل يؤثر سلباً على حياتي الشخصية', reverse: true },
  { id: 26, dimension: 'balance', text: 'أثق في استمرارية المنظمة ونجاحها', reverse: false },
  { id: 27, dimension: 'balance', text: 'القلق من فقدان الوظيفة يشغل تفكيري', reverse: true },
  { id: 28, dimension: 'balance', text: 'ساعات العمل مرنة وتناسب ظروفي', reverse: false },
  
  // العدالة والتواصل (29-35)
  { id: 29, dimension: 'fairness', text: 'أحصل على راتب ومزايا عادلة مقارنة بجهدي', reverse: false },
  { id: 30, dimension: 'fairness', text: 'التواصل في المنظمة واضح وشفاف', reverse: false },
  { id: 31, dimension: 'fairness', text: 'يتم التعامل مع جميع الموظفين بعدالة ومساواة', reverse: false },
  { id: 32, dimension: 'fairness', text: 'المعلومات المهمة لا تصلني في الوقت المناسب', reverse: true },
  { id: 33, dimension: 'fairness', text: 'آرائي ومقترحاتي يتم الاستماع إليها', reverse: false },
  { id: 34, dimension: 'fairness', text: 'نظام الترقيات والمكافآت غير واضح أو عادل', reverse: true },
  { id: 35, dimension: 'fairness', text: 'أفهم أهداف المنظمة ودوري في تحقيقها', reverse: false },
];

export const interpretations = {
  excellent: {
    range: [4.2, 5.0],
    percentage: [84, 100],
    label: 'ممتاز',
    description: 'بيئة عمل مثالية تعزز السعادة والإنتاجية',
    color: '#00695C'
  },
  veryGood: {
    range: [3.6, 4.1],
    percentage: [72, 82],
    label: 'جيد جداً',
    description: 'بيئة إيجابية مع فرص للتحسين',
    color: '#00897B'
  },
  good: {
    range: [3.0, 3.5],
    percentage: [60, 70],
    label: 'جيد',
    description: 'مستوى مقبول يحتاج لبعض التحسينات',
    color: '#F9A825'
  },
  weak: {
    range: [2.0, 2.9],
    percentage: [40, 58],
    label: 'ضعيف',
    description: 'تحديات واضحة تتطلب تدخل عاجل',
    color: '#FFA726'
  },
  critical: {
    range: [1.0, 1.9],
    percentage: [20, 38],
    label: 'حرج',
    description: 'مشاكل خطيرة تتطلب إعادة هيكلة',
    color: '#E74C3C'
  }
};

export const recommendations = {
  leadership: {
    weak: [
      'تطوير برامج تدريب القيادة للمدراء',
      'إنشاء نظام تقدير فوري وواضح',
      'تحسين التواصل بين القيادة والموظفين',
      'وضع رؤية واضحة ومشاركتها مع الجميع',
      'الاحتفال الدوري بالإنجازات'
    ],
    strong: [
      'الحفاظ على ممارسات القيادة الحالية',
      'توثيق أفضل الممارسات القيادية',
      'نشر ثقافة القيادة الإيجابية'
    ]
  },
  meaning: {
    weak: [
      'ربط أدوار الموظفين بالرسالة الكبرى للمنظمة',
      'وضع خطط تطور مهني واضحة لكل موظف',
      'توفير مشاريع ذات معنى وتأثير',
      'تعزيز التوافق بين قيم الموظفين والمنظمة',
      'توضيح مسارات الترقي والنمو'
    ],
    strong: [
      'مشاركة قصص النجاح والتأثير',
      'الاستمرار في برامج التطوير',
      'تعزيز ثقافة الهدف والمعنى'
    ]
  },
  relationships: {
    weak: [
      'تنظيم أنشطة بناء الفريق',
      'تحسين البيئة المادية للعمل',
      'معالجة الصراعات بشكل فوري',
      'توفير الأدوات والموارد اللازمة',
      'تعزيز ثقافة الاحترام والتعاون'
    ],
    strong: [
      'الحفاظ على جو العمل الإيجابي',
      'تشجيع التعاون بين الأقسام',
      'الاحتفال بروح الفريق'
    ]
  },
  balance: {
    weak: [
      'تطبيق سياسات عمل مرنة',
      'توفير برامج دعم الصحة النفسية',
      'توضيح مستقبل المنظمة للموظفين',
      'مراجعة أعباء العمل وتوزيعها',
      'تعزيز الأمان الوظيفي'
    ],
    strong: [
      'الاستمرار في دعم التوازن',
      'مشاركة أفضل ممارسات التوازن',
      'تقدير الموظفين الملتزمين'
    ]
  },
  fairness: {
    weak: [
      'مراجعة هيكل الرواتب والمزايا',
      'تحسين قنوات التواصل الداخلي',
      'وضع نظام شفاف للترقيات',
      'ضمان العدالة في المعاملة',
      'تفعيل آليات الاستماع للموظفين'
    ],
    strong: [
      'الحفاظ على الشفافية',
      'تعزيز ثقافة العدالة',
      'الاستمرار في التواصل المفتوح'
    ]
  }
};
